import { ElNotification, type NotificationParamsTyped } from "element-plus";
import { useI18n } from "vue-i18n";
import { h } from "vue";
import { useIntercom } from "./intercom";

export const useNotification = () => {
  const { tm, rt } = useI18n();
  const { showIntercom } = useIntercom();

  return {
    sendSuccessNotification: (options: NotificationParamsTyped) => {
      return ElNotification.success(options);
    },
    sendErrorNotification: (
      options: NotificationParamsTyped,
      displayContactSupportMsg = false
    ) => {
      if (displayContactSupportMsg && typeof options === "string") {
        const persistingProblemMessages = tm("errors.contactSupport");
        return ElNotification.error({
          title: options,
          message: h("p", [
            h("span", rt(persistingProblemMessages[0])),
            h("span", {
              class: "link",
              innerHTML: rt(persistingProblemMessages[1]),
              onClick: showIntercom,
            }),
          ]),
          duration: 6000,
          offset: 80,
        });
      }

      return ElNotification.error(options);
    },
    sendWarningNotification: (options: NotificationParamsTyped) => {
      return ElNotification.warning(options);
    },
    sendInfoNotification: (options: NotificationParamsTyped) => {
      return ElNotification.info(options);
    },
  };
};
